import { UploadOutlined } from "@ant-design/icons"
import { Button, Upload, type UploadProps } from "antd"
import React from "react"

import { validateFile } from "../../../../utils/file-validation.ts"
import {
  COMPLIANCE_DOCUMENT_EXTENSIONS,
  COMPLIANCE_DOCUMENT_MAX_MB
} from "../../constants/compliance.ts"

interface DocumentUploadProps extends UploadProps {
  buttonLabel?: string
}

/**
 * One compliance document, held until the form is submitted. The type and size
 * are checked here so a bad file is refused at selection rather than after the
 * whole form has been sent and rejected by the server.
 */
export const DocumentUpload = ({
  buttonLabel = "Select file",
  ...uploadProps
}: DocumentUploadProps) => (
  <Upload
    maxCount={1}
    accept={COMPLIANCE_DOCUMENT_EXTENSIONS.map((ext) => `.${ext}`).join(",")}
    beforeUpload={(file) =>
      validateFile(file, {
        maxSize: COMPLIANCE_DOCUMENT_MAX_MB,
        allowedExtensions: COMPLIANCE_DOCUMENT_EXTENSIONS,
        defaultResult: false
      })
    }
    {...uploadProps}
  >
    <Button size="large" icon={<UploadOutlined />}>
      {buttonLabel}
    </Button>
  </Upload>
)
